import React, { useContext, useEffect, useMemo } from 'react';
import Header from '../../Components/Header/Header';
import Footer from '../../Components/Footer/Footer';
import StaffCheckStepFrame from '../../Components/StaffCheckStep/StaffCheckStepFrame';
import StaffCheckStep_1 from '../../Components/StaffCheckStep/StaffCheckStep_1';
import StaffCheckStep_2 from '../../Components/StaffCheckStep/StaffCheckStep_2';
import StaffCheckStep_3 from '../../Components/StaffCheckStep/StaffCheckStep_3';
import StaffCheckStep_3_mealOverview from '../../Components/StaffCheckStep/StaffCheckStep_3_mealOverview';
import StaffCheckStep_3_mealInfo from '../../Components/StaffCheckStep/StaffCheckStep_3_mealInfo';
import { Global } from '../../App';
import qs from 'querystring';
import '../pages.scss';
// switch lang
import { langStringToCode } from '../../Share/Tools/switchLang';

// api test
import { getOrderInfo } from '../../Api/staff/GetOrderInfo';
import ErrorPage from '../Error/Error'
import { useCallback } from 'react';
import { useState } from 'react';
import fp from 'lodash/fp'

function StaffCheckOrder(props) {
  const { globalState, dispatchGlobal } = useContext(Global);
  const { history } = props
  const { search } = props.location
  const [state, setState] = useState({
    code: undefined,
    isReady: false,
    isError: false,
    errCode: undefined,
    errMessage: undefined,
    errBackStep: undefined
  })

  useEffect(() => {
    if (search !== '') {
      const { orderCode: code } = qs.parse(search.slice(1));

      setState({
        code,
        isReady: true
      });

      history.push('/staffCheckOrder')

      // 如果暫存在訂單詳細頁，則退回到掃描頁重新綁定訂單資料
      if (parseInt(globalState.staffInfo.currentCheckOrderStep) >= 3) {
        dispatchGlobal({
          type: 'UPDATE',
          payload: [
            { key: 'staffInfo.currentCheckOrderStep', val: '2' }
          ]
        })
      }

    } else {
      setState((prevState) => {
        return {
          ...prevState,
          isReady: true
        }
      })
    }
  }, [search, history, dispatchGlobal, globalState.staffInfo.currentCheckOrderStep])

  const $handleError = useCallback(({
    errCode,
    errMessage,
    backStep
  }) => {
    setState(fp.assign(fp.__, {
      isError: true,
      errCode,
      errMessage,
      errorBackStep: backStep
    }))
    // dispatchGlobal({
    //   type: 'UPDATE',
    //   payload: [
    //     { key: 'staffInfo.currentCheckOrderStep', val: '0' },
    //     { key: 'errMsg', val: errCode }
    //   ]
    // })
  }, [])

  // 驗證
  async function apiVerifyQRCode() {
    const { langType, staffInfo } = globalState;
    try {
      // 似乎無用到?
      const res = await getOrderInfo(
        langStringToCode(langType),
        staffInfo.checkOrderStaff.staffCode
      );
      const { errCode } = res.data;

      if (errCode == 200) {
        return res;
      } else {
        $handleError({ errCode })
      }
    } catch (err) {
      $handleError({ errCode: 413 })
    }
  }

  const handler = useCallback(() => {
    dispatchGlobal({
      type: 'UPDATE',
      payload: [
        {
          key: 'staffInfo.isReady',
          val: {
            isReady: true
          }
        }
      ]
    });
  }, [dispatchGlobal])

  function renderStep(step) {
    if (state.isError) {
      return (
        <ErrorPage
          errCode={state.errCode}
          errMessage={state.errMessage}
          onBack={() => {
            let payload = [
              { key: 'staffInfo.currentCheckOrderStep', val: state.errorBackStep },
            ]

            if (state.errorBackStep === '1') {
              payload.push({
                key: 'staffInfo.checkOrderData', val: undefined
              })
            }

            dispatchGlobal({
              type: 'UPDATE',
              payload
            })

            setState(fp.assign(fp.__, {
              isError: false
            }))
          }}
        />
      )
    }

    console.log('staff check step', step)

    switch (step) {
      case '1':
        return (
          <>
            <Header />
            <StaffCheckStepFrame>
              <StaffCheckStep_1
                onError={(errCode, errMessage) => {
                  $handleError({
                    errCode,
                    errMessage,
                    backStep: '1'
                  })
                }}
              />
            </StaffCheckStepFrame>
            <Footer />
          </>
        );
      case '2':
        return (
          <>
            <Header />
            <StaffCheckStepFrame>
              <StaffCheckStep_2
                code={state.code}
                onClearCode={() => {
                  setState(({ code, ...prevState }) => prevState)
                }}
                onError={(errCode, errMessage) => {

                  $handleError({
                    errCode,
                    errMessage,
                    backStep: '1'
                  })
                }}
              />
            </StaffCheckStepFrame>
            <Footer />
          </>
        );
      case '3':
        return (
          <>
            <Header />
            <StaffCheckStepFrame>
              <StaffCheckStep_3
                onError={(errCode, errMessage, backStep) => {
                  $handleError({
                    errCode,
                    errMessage,
                    backStep: backStep || '2'
                  })
                }}
              />
            </StaffCheckStepFrame>
            <Footer />
          </>
        );
      case '3.1':
        return (
          <>
            <Header />
            <StaffCheckStepFrame>
              <StaffCheckStep_3_mealOverview />
            </StaffCheckStepFrame>
            <Footer />
          </>
        );
      case '3.2':
        return (
          <>
            <Header />
            <StaffCheckStep_3_mealInfo />
            <Footer />
          </>
        );
      default:
        throw Error('step page error.');
    }
  }
  
  useEffect(() => {
    handler();
  }, [handler]);

  useEffect(() => {
    window.document.body.scrollTop = 0;
  }, [globalState.staffInfo.currentCheckOrderStep])

  return (
    <div className="Pages">
      {renderStep(globalState.staffInfo.currentCheckOrderStep)}
    </div>
  );
}

export default StaffCheckOrder;
